module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Bold-b1ee8fbc23ae845f1c83be645ac0a290.ttf";